// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C6i-H","col":"styles_col__fmhAp"};